import { Button, Modal, Form, Input } from "antd"
import React from "react"
import { MainActions, AuthActions } from "redux-store/models"
import { connect } from "react-redux"

const CancelServiceForm = ({ isVisible, onClose, form, record, handleSubmit }) => {
  const { getFieldDecorator, validateFields } = form

  const handleSubmitForm = () => {
    validateFields((err, values) => {
      if (!err) {
        handleSubmit(values)
      }
    })
  }

  return (
    <Modal
      className="cancel-service-modal"
      title={
        <div className="cancel-title-wrapper">
          <div className="title-row">
            <div className="icon-box">!</div>
            <p className="title">Conferma cancellazione</p>
          </div>

          <p className="subtitle">
            Vuoi cancellare/rimborsare il codice {record?.barcode}?
          </p>

          <span className="service-name">(Service: {record?.service})</span>
        </div>
      }
      visible={isVisible}
      onCancel={onClose}
      width={500}
      footer={
        <div className="footer-actions">
          <Button type="primary" onClick={onClose} className="annulla">
            Annulla
          </Button>

          <Button type="primary" className="confirm" onClick={handleSubmitForm}>
            Conferma
          </Button>
        </div>
      }
    >
      <Form layout="vertical" className="cancel-service-form">
        <Form.Item label="Nome operatore">
          {getFieldDecorator("nome_operatore", {
            rules: [
              {
                required: true,
                message: "Inserisci il nome operatore!",
              },
            ],
          })(<Input type="text" placeholder="Nome operatore" />)}
        </Form.Item>

        <Form.Item label="Motivo della cancellazione">
          {getFieldDecorator("description", {
            rules: [
              {
                required: true,
                message: "Inserisci il motivo della cancellazione!",
              },
            ],
          })(<Input.TextArea rows={3} placeholder="Motivo della cancellazione" />)}
        </Form.Item>
      </Form>
    </Modal>
  )
}

const CancelServiceFormForm = Form.create()(CancelServiceForm)

const mapsStateToProps = ({ main, auth }) => ({
  activeSkinId: main.activeSkinId,
  categories: auth.allServices.categories,
})

export default connect(mapsStateToProps, { ...MainActions, ...AuthActions })(
  CancelServiceFormForm
)
